import { EXTERNAL_ICON_URLS } from './canvasData'

export const loadedImages = {}

export function preloadImages(done) {
  const entries = Object.entries(EXTERNAL_ICON_URLS)
  if (!entries.length) { done(); return }
  let remaining = entries.length
  entries.forEach(([label, url]) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => { loadedImages[label] = img; if (!--remaining) done() }
    img.onerror = () => { if (!--remaining) done() }
    img.src = url
  })
}
